//@ts-ignore
import * as WindowActions from '@alme/ui-web/modules/window-jquery-drag/src/actions/actions'
import * as LanguageActions from './actions/actions'
import reducer from './reducers/reducers'
//@ts-ignore
import watch from 'redux-watch'
import settings from '@alme/ui-web/settings/settings';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import {EntryOriginTypesV5} from '@alme/api-ts/Alme/EntryOriginTypes';

/*
    Module responsible for any non-standard to HappyMeal changes that occur on language update
*/
export default class CustomLanguageHandler {

    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(passedSettings: AlightCustomSettingsType) {
        this._settings = passedSettings;
    }

    static getDefaultSettings() {
        return settings
    }

    getReducer()
    {
        return reducer;
    }


    initialize(store: Store<AlmeState>) {
        this._store = store;

        let base = this._settings.stateLocations.Conversation.Base;
        let location = this._settings.stateLocations.Conversation.language;

        let langStateLocation = `${base}.${location}`
        let watcher = watch(this._store.getState, langStateLocation);
        this._store.subscribe(watcher((newVal: string, oldVal: string, objectPath: string) => {
            if (oldVal != ""){
                return this.doUpdate(newVal);
            }
        }));
    }

    async getPromise() {
        return new Promise((resolve) => {
            let location = this._settings.stateLocations.Conversation.language;
            let lang = this._settings.languageConstants.languages[this._settings.languageConstants.default]

            this._store?.dispatch(LanguageActions.setLanguage(lang, location));

            //@ts-ignore
            resolve();
            return;
        });
    }


    doUpdate(value: string) {
        if (value in this._settings.languageSpecificSettingOverrides) {
            this.resetToDefaultWindowPosition();

            const inActiveSession = this._store?.getState()?.Conversation?.IsActiveSession ?? false;

            if (inActiveSession){
                const input = {
                    messageType: this._settings.messageConstants.appeventRequest,
                    eventName: "LanguageChangeDetected",
                    origin: this._settings.originConstants.internal as EntryOriginTypesV5,
                    parameters: {},
                }
        
                sendRequest(input);
            }
            
        }
    }

    resetToDefaultWindowPosition(){
        let xPos = (window.innerWidth - this._settings.textConstants.xPosition) + "px";
        let yPos = (window.innerHeight - this._settings.textConstants.yPosition) + "px";
        let positionStateLoc = this._settings.stateLocations.Window.position;

        this._store?.dispatch(WindowActions.setWindowPosition({
            xPos: xPos,
            yPos: yPos
        }, positionStateLoc));
    }

}


// WEBPACK FOOTER //
// ./modules/custom-language-watcher/custom-language-watcher.ts